export default __webpack_public_path__ + "static/media/tools-03.8ef73fb7.png";